import React from 'react';
import type { RenderColumnDataProps } from 'c-pagination';
import type { Campaign } from 'c-sdk';
import { NumberFormat } from 'c-components';
import { Box, Tooltip } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';

import { Translate } from 'c-translation';
import { playoutPercentColor, resolvePlayoutDisplay } from './playoutDisplay';

type Props = RenderColumnDataProps<Campaign>;

const CampaignPlayoutsCell: React.FC<Props> = ({ entity }) => {
    if (entity.playout_percentage == null) return null;

    const display = resolvePlayoutDisplay(entity);

    if (display.kind === 'none') return <>-</>;

    if (display.kind === 'impactsWithoutExpected') {
        return (
            <Tooltip
                title={
                    <Translate path="Modules.Main.Campaigns.List.table.playoutNoExpectedImpactsTooltip" />
                }
            >
                <ErrorOutline color="warning" fontSize="small" />
            </Tooltip>
        );
    }

    return (
        <Tooltip
            title={
                <Box>
                    <Translate path={display.tooltip} />
                </Box>
            }
        >
            <Box color={playoutPercentColor(display.value)}>
                <NumberFormat value={display.value} />%
            </Box>
        </Tooltip>
    );
};

export default CampaignPlayoutsCell;
